import {ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {DomSanitizer} from "@angular/platform-browser";
import {MatIconRegistry} from "@angular/material/icon";

@Component({
  selector: 'app-svg-icon',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-card appearance="outlined" class="thumbs" fxFlex="0 1 calc(100% - 32px)" fxFlex.lt-md="0 1 calc(50% - 32px)" fxFlex.lt-sm="100%">
      <img mat-card-image [src]="photo1">
    </mat-card>
    <!-- <div type="image/svg+xml" class="fade-in" *ngIf="photo1" [ngStyle]="{'backgroundWidth': '100px', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center',  'background-image': 'url(' + photo1 + ')'}"></div> -->
    <!-- <img loading="lazy" mat-card-image [src]="photo1"/> -->
  `
})
export class SvgIconComponent {
  @Input()
  set path(val: string) {
    // res.url = 'https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business577621/resources/204.svg';
    // res.url = 'https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business391060/resources/477.svg';
    // res.url = 'https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business577621/resources/204.svg';
    // https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business577621/resources/224.svg
    // https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business577621/resources/204.svg
    // https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business391060/resources/477.svg
    // https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business577621/resources/207.svg
    // val = 'https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business577621/resources/204.svg';
    // val = 'https://ida.signage.me/Web/redirectRequest.ashx?url=https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business391060/resources/477.svg';
    // console.log('SVG ' + val);
    this.loadSvg(val);
  }

  @Input() height;
  @Input() width;
  @Input() alt: string;
  @ViewChild('component', {static: true}) component;
  photo1;

  constructor(private http: HttpClient,
              private elementRef: ElementRef,
              private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
  }

  bypassSecurityboxCors(i_file) {
    this.iconRegistry.addSvgIcon(
      'my-star-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl(i_file)
    );
    console.log('load bypassing CORS: ' + i_file);
  }

  loadSvg(val: string) {
    this.photo1 = val;
  }
}


// this.http.get(`svgs/${val}.svg`) // grab locally
// val = 'https://earth.signage.me/Web/redirectRequest.ashx?url=http://s3-us-west-2.amazonaws.com/oregon-signage-resources/business391060/resources/477.svg';
// val = 'https://s3-us-west-2.amazonaws.com/oregon-signage-resources/business391060/resources/477.svg';
// this.http.get(val, {
//   headers: new HttpHeaders({'Content-Type': '`application/json'}),
//   responseType: 'text' as 'json'
// }).pipe(
//   take(1),
//   catchError((err) => {
//     const msg = this.translocoService.translate('toast.errorLoadingImg', {}, this.translocoService.getActiveLang());
//     this.onError(msg);
//     // return Observable.of(true);
//     return throwError(err);
//   }),
//   finalize(() => {
//     // console.log('done');
//   }))
//   .subscribe(
//     res => {
//       // get our element and clean it out
//       // const element = this.elementRef.nativeElement;
//       // var svgFinal;
//       // element.innerHTML = '';
//       // // get response and build svg element
//       // var response = res.toString();
//       // const parser = new DOMParser();
//       //
//       //
//       // if (this.height && this.width) {
//       //   var svgHeight, svgWidth, re;
//       //   svgHeight = response.match(/(height=")([^\"]*)/)[2];
//       //   re = new RegExp('height="' + svgHeight + '"', "ig");
//       //   response = response.replace(re, `height="${this.height}"`);
//       //
//       //   svgWidth = response.match(/(width=")([^\"]*)/)[2];
//       //   re = new RegExp('width="' + svgWidth + '"', "ig");
//       //   response = response.replace(re, `width="${this.width}"`);
//       //   // var s = new String(response);
//       // }
//
//       // svgFinal = parser.parseFromString(response, 'image/svg+xml');
//       // this.photo = svgFinal;
//       // element.appendChild(svgFinal.documentElement);
//       // this.component.nativeElement.appendChild(svgFinal);
//       // insert the svg result
//     },
//     err => {
//       console.error(err);
//     });
